"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_sanofi/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../../targets/cord_sanofi/cssConstants.js"));

var _Nugget = _interopRequireDefault(require("./Nugget.scss"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../../KESI2/KesiConstants");

var _PDFNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/PDFNugget"));

var _index = require("../../../../KESI2/Services/RemoteControlService/index");

var _KESI2Helper = _interopRequireWildcard(require("../../../../KESI2/KESI2Helper"));

var _Spinner = _interopRequireDefault(require("../../Spinner/Spinner"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _DrupalPDFNugget = _interopRequireDefault(require("./DrupalPDFNugget.scss"));

var _PDF = require("../../../../utils/PDF");

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _FeedbackService = require("../../../../KESI2/Services/FeedbackService");

var _ArrayHelper = require("../../../../helpers/ArrayHelper");

var _CordovaFileHelper = _interopRequireWildcard(require("../../../../helpers/CordovaFileHelper"));

var _FileTransferWrapper = _interopRequireDefault(require("../../../../cordovaPluginWrappers/FileTransferWrapper"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _MuiAlertHelper = require("../../../../helpers/MuiAlertHelper");

var _DrupalPDFNuggetStrings = require("./DrupalPDFNuggetStrings");

var _Image = _interopRequireDefault(require("../../Image/Image"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DOM_PREFIX = 'pdfContainer_';
var DOCUMENT_ID = 'documentId_';

var DrupalPDFNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalPDFNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalPDFNugget);

  function DrupalPDFNugget(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, DrupalPDFNugget);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "checkEnterKey", function (event) {
      if (event.key === 'Enter') {
        var nugget = _this.state.content[_this.props.id];
        var el = document.activeElement;

        if (el) {
          console.log('checkEnterKey QuizNugget', el.id);

          if (el.id.indexOf('pdfOpenBtn') > -1) {
            var idParts = el.id.split('_');
            var index = idParts.length > 1 ? idParts[1] : null;

            if (index) {
              var sortedDocs = nugget.documents;
              var docToOpen = sortedDocs[index];

              if (docToOpen) {
                _this.openPDF(docToOpen);
              }
            }
          }
        }
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "checkOfflineAvailability", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var nugget, offlineAvailable, promises;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log('checkOfflineAvailability');
              nugget = _this.getNugget();
              offlineAvailable = {};
              promises = nugget.documents && nugget.documents.length > 0 && nugget.documents.map(function (pdfDoc) {
                if (!pdfDoc) {
                  return null;
                }

                return new _promise["default"]( /*#__PURE__*/function () {
                  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(resolve, reject) {
                    var pdfName, fileExists;
                    return _regenerator["default"].wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.prev = 0;
                            pdfName = _this.getPDFStorageName(pdfDoc);
                            _context.next = 4;
                            return _CordovaFileHelper["default"].fileExists(pdfName, _CordovaFileHelper.LOCAL_FILENAMES.DOWNLOAD_FOLDER);

                          case 4:
                            fileExists = _context.sent;
                            offlineAvailable[pdfDoc.id] = !!fileExists;
                            _context.next = 12;
                            break;

                          case 8:
                            _context.prev = 8;
                            _context.t0 = _context["catch"](0);
                            console.log('checkOfflineAvailability error', _context.t0);
                            offlineAvailable[pdfDoc.id] = false;

                          case 12:
                            resolve();

                          case 13:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[0, 8]]);
                  }));

                  return function (_x, _x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());
              });
              _context2.next = 6;
              return _promise["default"].all(promises);

            case 6:
              console.log('setting offlineAvailable to', offlineAvailable);

              _this.setState({
                offlineAvailable: offlineAvailable
              });

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDomId", function () {
      return "".concat(DOM_PREFIX).concat(_this.props.id);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "sortById", function (contents) {
      return contents.sort(function (content1, content2) {
        return content1.id - content2.id;
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "openPDF", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(pdfDoc) {
        var nugget, pdfName, downloadFolder, fileExists, openedDocs, index;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                nugget = _this.getNugget();
                console.log('openPDF', pdfDoc);
                _context3.prev = 2;

                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context3.next = 7;
                  break;
                }

                window.open(pdfDoc.url, '_blank');
                _context3.next = 16;
                break;

              case 7:
                pdfName = _this.getPDFStorageName(pdfDoc);
                _context3.next = 10;
                return _CordovaFileHelper["default"].getDownloadFolder();

              case 10:
                downloadFolder = _context3.sent;
                _context3.next = 13;
                return _CordovaFileHelper["default"].fileExists(pdfName, downloadFolder.name);

              case 13:
                fileExists = _context3.sent;
                console.log('openPDF', fileExists, downloadFolder);

                if (fileExists) {
                  (0, _PDF.openPDF)("".concat(downloadFolder.nativeURL).concat(pdfName));
                } else {
                  window.open(pdfDoc.url, '_system');
                }

              case 16:
                openedDocs = _this.state.openedDocuments;
                index = openedDocs.indexOf(pdfDoc.id);

                if (index < 0) {
                  openedDocs.push(pdfDoc.id);

                  if (openedDocs.length === nugget.documents.length) {
                    _this.props.markAsRead(_this.props.id);
                  }
                }

                _context3.next = 25;
                break;

              case 21:
                _context3.prev = 21;
                _context3.t0 = _context3["catch"](2);
                console.log('openPDF', _context3.t0);
                window.open(pdfDoc.url, '_system');

              case 25:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[2, 21]]);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getPDFStorageName", function (pdfDoc) {
      var pdfName = pdfDoc.localName.replace('/', '_');
      return pdfName;
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "deletePDF", /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(pdfDoc) {
        var pdfName, downloadFolder;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log('deletePDF', pdfDoc);
                _context4.prev = 1;
                pdfName = _this.getPDFStorageName(pdfDoc);
                _context4.next = 5;
                return _CordovaFileHelper["default"].getDownloadFolder();

              case 5:
                downloadFolder = _context4.sent;
                _context4.next = 8;
                return _CordovaFileHelper["default"].deleteFile(pdfName, downloadFolder.name);

              case 8:
                _context4.next = 13;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](1);
                console.error("error deleting file ".concat(pdfDoc.name, ": "), _context4.t0);

              case 13:
                _this.checkOfflineAvailability();

                _this.forceUpdate();

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[1, 10]]);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "downloadPDF", /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(pdfDoc) {
        var downloadFolder, online, onProgress, downloadableSrc, pdfName;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                console.log('downloadPDF');

                if (!_this.isDownloading) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt("return", _promise["default"].reject(new Error('already downloading')));

              case 3:
                _context5.next = 5;
                return _CordovaFileHelper["default"].getDownloadFolder();

              case 5:
                downloadFolder = _context5.sent;
                console.log('downloadFolder exists ? ', downloadFolder);
                online = _DeviceInfoHelper["default"].isOnline();

                if (online) {
                  _context5.next = 12;
                  break;
                }

                console.log('downloadPDF not online');
                (0, _MuiAlertHelper.showWideAlertHtml)((0, _DrupalPDFNuggetStrings.getString)('OFFLINE_TEXT'), (0, _DrupalPDFNuggetStrings.getString)('OFFLINE_TITLE'));
                return _context5.abrupt("return");

              case 12:
                _this.isDownloading = true;

                _this.setState({
                  loadingId: pdfDoc.id
                });

                _context5.prev = 14;

                onProgress = function onProgress(evt) {
                  if (!evt || !evt.loaded || !evt.total) {
                    console.error('unexpected progress event');

                    _this.setProgress(-1);

                    return;
                  }

                  var progressPercent = Math.floor(evt.loaded / evt.total * 100);

                  _this.setProgress(progressPercent);
                };

                console.log('downloadPDF2');

                _this.setProgress(0);

                downloadableSrc = pdfDoc.url;
                console.log('downloadPDF3');
                pdfName = _this.getPDFStorageName(pdfDoc);
                _context5.next = 23;
                return new _FileTransferWrapper["default"]().downloadWithJS(downloadableSrc, pdfName, downloadFolder.name, onProgress, true);

              case 23:
                console.log('downloadPDF4');

                _this.checkOfflineAvailability();

                _context5.next = 30;
                break;

              case 27:
                _context5.prev = 27;
                _context5.t0 = _context5["catch"](14);
                console.error('error downloading video', _context5.t0);

              case 30:
                _this.isDownloading = false;

                _this.setState({
                  loadingId: null
                });

                _this.forceUpdate();

                return _context5.abrupt("return", _promise["default"].resolve());

              case 34:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[14, 27]]);
      }));

      return function (_x5) {
        return _ref5.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "replaceHrefs", function (htmlStr) {
      var newStr = htmlStr.replace(/<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1/g, function (match, p1, p2) {
        // do not replace mailto links etc
        if (match.indexOf('http') !== -1) {
          return "<a href=\"javascript:;\" onclick=\"window.open('".concat(p2, "', '_system')\"");
        }

        return match;
      });
      return newStr;
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "renderCompleteDocument", function (pdfDoc) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: pdfDoc.id,
        className: _DrupalPDFNugget["default"].singleFileContainer
      }, pdfDoc.show_title ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalPDFNugget["default"].singleFileTitle
      }, pdfDoc.title) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalPDFNugget["default"].singleFileHeader
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalPDFNugget["default"].singleFileName
      }, pdfDoc.name_to_show), /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: 'Download Icon',
        tabIndex: 0,
        className: "".concat(_DrupalPDFNugget["default"].singleFileDownloadButton, " doNotInvert"),
        src: _config["default"].downloadIcon,
        onClick: function onClick() {
          return _this.openPDF(pdfDoc);
        }
      })), !_DeviceInfoHelper["default"].isBrowser() && /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalPDFNugget["default"].downloadButton,
        style: {
          backgroundColor: _config["default"].useTileBackgroundColorInTile && _this.props.forcedUIColor ? _this.props.forcedUIColor : _cssConstants["default"].colors.buttonBackground
        }
      }, _this.state.loadingId === pdfDoc.id ? /*#__PURE__*/_react["default"].createElement("img", {
        src: _config["default"].loadingIcon,
        className: _DrupalPDFNugget["default"].loadingIcon,
        onClick: function onClick() {
          return _this.deletePDF(pdfDoc);
        }
      }) : _this.state.offlineAvailable[pdfDoc.id] ? /*#__PURE__*/_react["default"].createElement("img", {
        src: _config["default"].deleteIcon,
        onClick: function onClick() {
          return _this.deletePDF(pdfDoc);
        }
      }) : /*#__PURE__*/_react["default"].createElement("img", {
        src: _config["default"].downloadIcon,
        onClick: function onClick() {
          return _this.downloadPDF(pdfDoc);
        }
      })), pdfDoc.info ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalPDFNugget["default"].singleFileInfo,
        dangerouslySetInnerHTML: {
          __html: pdfDoc.info
        }
      }) : null, /*#__PURE__*/_react["default"].createElement("hr", {
        className: _DrupalPDFNugget["default"].singleFileDivider
      }));
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "renderSmallDocument", function (pdfDoc, index) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: pdfDoc.id,
        className: _DrupalPDFNugget["default"].listItem
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalPDFNugget["default"].pdfTitle
      }, pdfDoc.name_to_show), /*#__PURE__*/_react["default"].createElement("div", {
        tabIndex: 0,
        id: "pdfOpenBtn_".concat(index),
        className: "".concat(_DeviceInfoHelper["default"].isBrowser() ? _DrupalPDFNugget["default"].pdfButton : _DrupalPDFNugget["default"].pdfButtonWithIcon, " doNotInvert"),
        style: {
          backgroundColor: _config["default"].useTileBackgroundColorInTile && _this.props.forcedUIColor ? _this.props.forcedUIColor : _cssConstants["default"].colors.buttonBackground
        },
        onClick: function onClick() {
          _this.openPDF(pdfDoc);
        }
      }, (0, _DrupalPDFNuggetStrings.getString)('PDF_NUGGET_OPEN_PDF')), !_DeviceInfoHelper["default"].isBrowser() && /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalPDFNugget["default"].downloadButton,
        style: {
          backgroundColor: _config["default"].useTileBackgroundColorInTile && _this.props.forcedUIColor ? _this.props.forcedUIColor : _cssConstants["default"].colors.buttonBackground
        }
      }, _this.state.loadingId === pdfDoc.id ? /*#__PURE__*/_react["default"].createElement("img", {
        src: _config["default"].loadingIcon,
        className: _DrupalPDFNugget["default"].loadingIcon,
        onClick: function onClick() {
          return _this.deletePDF(pdfDoc);
        }
      }) : _this.state.offlineAvailable[pdfDoc.id] ? /*#__PURE__*/_react["default"].createElement("img", {
        src: _config["default"].deleteIcon,
        onClick: function onClick() {
          return _this.deletePDF(pdfDoc);
        }
      }) : /*#__PURE__*/_react["default"].createElement("img", {
        src: _config["default"].downloadIcon,
        onClick: function onClick() {
          return _this.downloadPDF(pdfDoc);
        }
      })));
    });
    _this.state = _objectSpread({
      // the nugget will be put there on a magic way by Reflux and props.id which is given in the constructor
      downloadProgress: -1,
      offlineAvailable: {},
      loadingId: null,
      openedDocuments: []
    }, _this.state);

    _this.props.registerNugget(_this.props.id, _PDFNugget["default"].CLASS, _this.getDomId(), _this.props.inSwipeContainer || _this.props.inGalleryContainer || _this.props.inListContainer);

    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(DrupalPDFNugget.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES, _DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, _DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA]);
    _this.isDownloading = false;
    _this.nextDownloadProgressToSet = null;
    _this.progressTimeout = null;
    return _this;
  }

  (0, _createClass2["default"])(DrupalPDFNugget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.registerNuggetPosition(this.props.id, _PDFNugget["default"].CLASS, this.getDomId());

      if (this.props.inListContainer) {
        this.props.setBackButtonFunc(this.props.goUpFunc);
      }

      this.checkOfflineAvailability();

      if (_DeviceInfoHelper["default"].isBrowser()) {
        window.addEventListener('keypress', function (event) {
          return _this2.checkEnterKey(event);
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      if (_DeviceInfoHelper["default"].isBrowser()) {
        window.removeEventListener('keypress', function (event) {
          return _this3.checkEnterKey(event);
        });
      }

      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalPDFNugget.prototype), "componentWillUnmount", this).call(this);
    }
  }, {
    key: "getNugget",

    /**
     * @returns {ErvCorporateNugget}
     */
    value: function getNugget() {
      return this.state.content[this.props.id];
    }
  }, {
    key: "setProgress",

    /**
     * Instead of setting the progress immediately, this functions only sets the last given progress once a second
     * @param progress
     */
    value: function setProgress(progress) {// this.nextDownloadProgressToSet = progress
      //
      // if (!this.progressTimeout) {
      //   this.progressTimeout = setTimeout(() => {
      //     this.setState({
      //       downloadProgress: this.nextDownloadProgressToSet
      //     })
      //     this.progressTimeout = null
      //   }, this.state.downloadProgress <= 0 ? 0 : 300)
      // }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var nugget = this.getNugget();
      var active = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(this.props.id, ".").concat(this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER))) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] || nugget.active : nugget.active;
      var outerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].outerHidden) : '';
      var sortedDocs = nugget.documents;
      var likes = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_LIKES) || [];
      var likeIndex = likes.indexOf(this.props.id);
      var allLikes = this.state.data[_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES];
      var currentLikesForId = allLikes && allLikes["".concat(this.props.id)] ? allLikes["".concat(this.props.id)] : 0;

      var isAuthor = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_SHOW_UNPUBLISHED_CONTENT);

      var replacedInfo = nugget.info ? this.replaceHrefs(nugget.info) : null;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "pdfContainer ".concat(_DeviceInfoHelper["default"].isBrowser() ? '' : 'mobile', " ").concat(this.getDomId(), " ").concat(_Nugget["default"].outerContainer, " ").concat(outerClassNames),
        id: this.getDomId(),
        style: this.props.inSwipeContainer || this.props.inListContainer || this.props.inGalleryContainer ? {
          width: '100%',
          padding: 0,
          margin: 0
        } : {}
      }, _config["default"].showNuggetIcons ? this.props.renderIcon(nugget) : null, /*#__PURE__*/_react["default"].createElement("div", null, isAuthor && !nugget.isPublished && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          padding: '10px',
          color: 'red'
        }
      }, "Content unver\xF6ffentlicht"), nugget.show_title && (_config["default"].targetTag !== "visitberlin" ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(this.props.inGalleryContainer ? 'titleSmall' : 'title')
      }, nugget.title) : /*#__PURE__*/_react["default"].createElement("h1", {
        className: this.props.inGalleryContainer ? 'titleSmall' : 'title'
      }, nugget.title)), nugget.info ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "info ".concat(_DrupalPDFNugget["default"].nuggetInfo),
        dangerouslySetInnerHTML: {
          __html: replacedInfo
        }
      }) : null, sortedDocs && sortedDocs.length > 0 && sortedDocs.map(function (pdfDoc, index) {
        if (!pdfDoc) {
          return null;
        }

        console.log('pdfDoc', pdfDoc);

        if (pdfDoc.info) {
          return _this4.renderCompleteDocument(pdfDoc, index);
        } else {
          return _this4.renderSmallDocument(pdfDoc, index);
        }
      })), _config["default"].hasLikeFunctionalityForNuggets && !this.props.inSwipeContainer && !this.props.inListContainer && !this.props.inGalleryContainer ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _Nugget["default"].likeContainer
      }, _config["default"].useTargetIcons ? /*#__PURE__*/_react["default"].createElement("img", {
        className: _Nugget["default"].svgLikeButton,
        onClick: function onClick() {
          return _this4.props.setLike();
        },
        src: likeIndex < 0 ? _config["default"].likeInactive : _config["default"].likeActive
      }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        onClick: function onClick() {
          return _this4.props.setLike();
        },
        className: likeIndex < 0 ? _Nugget["default"].likeButton : _Nugget["default"].likeButtonActivated,
        name: 'thumbs-o-up'
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Nugget["default"].likeText
      }, "".concat(currentLikesForId, " ").concat(currentLikesForId === 1 ? 'Like' : 'Likes'))) : null);
    }
  }]);
  return DrupalPDFNugget;
}(_KESI2BasicComponent["default"]);

exports["default"] = DrupalPDFNugget;
DrupalPDFNugget.propTypes = {
  id: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func.isRequired,
  markAsRead: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  inSwipeContainer: _propTypes["default"].bool.isRequired,
  regionCode: _propTypes["default"].string,
  setBackButtonFunc: _propTypes["default"].func,
  closeTile: _propTypes["default"].func,
  inListContainer: _propTypes["default"].bool.isRequired,
  inGalleryContainer: _propTypes["default"].bool.isRequired,
  goUpFunc: _propTypes["default"].func,
  renderIcon: _propTypes["default"].func.isRequired,
  forcedUIColor: _propTypes["default"].string,
  setLike: _propTypes["default"].func
};
DrupalPDFNugget.defaultProps = {
  id: null
};